export default __webpack_public_path__ + "static/media/allCourseFacebook-1200x630.97e4cd9f.jpg";